<template>
  <v-container fluid>
    <validation-observer :ref="validationRef">
      <v-row>
        <template v-if="hasLabel">
          <v-col cols="12" sm="12" class="my-1">
            <v-card outlined>
              <v-card-text class="pa-2">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" class="pa-0">
                      {{ label.trim() }}
                    </v-col>
                    <v-col cols="12" sm="6" class="pa-2">
                      <validation-provider rules="required" v-slot="{ errors }" :name="$t('location.fromDate')">
                        <date-time-filter
                          v-model="dates.begin"
                          :clearable="clearable"
                          :loading-data="loading"
                          :label="$t('subOrder.from') | uppercase"
                          :errors="errors"
                          :disabled="disabled"
                          :top="top"
                          :bottom="bottom"
                          :format="inputFormat"
                          @input="closeDatePicker()"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" sm="6" class="pa-2">
                      <validation-provider v-slot="{ errors }" :name="$t('location.toDate')" :rules="endDateRules">
                        <date-time-filter
                          v-model="dates.end"
                          :clearable="clearable"
                          :loading-data="loading"
                          :label="$t('location.toDate') | uppercase"
                          :errors="errors"
                          :disabled="disabled"
                          :top="top"
                          :bottom="bottom"
                          :format="inputFormat"
                          @input="closeDatePicker()"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="12" sm="6" class="pa-2">
            <validation-provider rules="required" v-slot="{ errors }" :name="$t('location.fromDate')">
              <date-time-filter
                v-model="dates.begin"
                :clearable="clearable"
                :loading-data="loading"
                :label="$t('subOrder.from') | uppercase"
                :errors="errors"
                :disabled="disabled"
                :top="top"
                :bottom="bottom"
                :format="inputFormat"
                @input="closeDatePicker()"
              />
            </validation-provider>
          </v-col>
          <v-col cols="12" sm="6" class="pa-2">
            <validation-provider v-slot="{ errors }" :name="$t('location.toDate')" :rules="endDateRules">
              <date-time-filter
                v-model="dates.end"
                :clearable="clearable"
                :loading-data="loading"
                :label="$t('location.toDate') | uppercase"
                :errors="errors"
                :disabled="disabled"
                :top="top"
                :bottom="bottom"
                :format="inputFormat"
                @input="closeDatePicker()"
              />
            </validation-provider>
          </v-col>
        </template>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import merge from 'lodash/merge'
  import DateTimeFilter from '@/components/inputs/DateTimeFilter'
  import { EventBus } from '@/event-bus'

  export default {
    name: 'ODateTimeRangeFilter',
    components: {
      DateTimeFilter,
      ValidationProvider,
      ValidationObserver
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
      label: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      validationRef: {
        type: String,
        default: 'closure'
      },
      top: {
        type: Boolean,
        default: true
      },
      bottom: {
        type: Boolean,
        default: false
      },
      format: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        defaultFormat: {
          date: {
            displayed: 'L LT',
          },
          time: {
            displayed: 'LT',
          },
        }
      }
    },
    computed: {
      dates: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
      hasLabel() {
        return this.label?.trim() !== ''
      },
      endDateRules() {
        return `required|end_after_begin_datetime:${this.dates.begin},${this.dates.end}`
      },
      inputFormat() {
        const defaultFormat = structuredClone(this.defaultFormat)
        merge(defaultFormat, this.format)
        return defaultFormat
      }
    },
    mounted() {
      EventBus.$on('validateDateTime', () => {
        this.closeDatePicker()
      })
    },
    beforeDestroy() {
      EventBus.$off('validateDateTime')
    },
    methods: {
      async closeDatePicker() {
        const success = await this.$refs[this.validationRef].validate()
        if (success) {
          EventBus.$emit('closeDateTimePicker')
        }
      },
      async validate() {
        return await this.$refs[this.validationRef].validate()
      }
    },
  }
</script>
